const SetSameTab = target => {
  const $allTabBtns = document.querySelectorAll(`tab-btn a[tab-target="${target}"]:not(.--active)`)

  if (!$allTabBtns.length > 0) return

  $allTabBtns.forEach($tabBtn => {
    $tabBtn.dispatchEvent(new Event('click'))
  })
}

const ToggleTab = ($tabContainer, $tabs, $tabBtns, $tabBtn) => {
  const target  = $tabBtn.getAttribute('tab-target')
  const $target = $tabContainer.querySelector(`[tab-origin="${target}"]`)

  $tabs.forEach($temp => {
    $temp.classList.remove('--active')
  })

  $tabBtns.forEach($temp => {
    $temp.classList.remove('--active')
  })

  $tabBtn.classList.add('--active')
  $target.classList.add('--active')

  SetSameTab(target)
}

const Tabs = () => {
  const $tabsContainer = document.querySelectorAll('tabs')

  if (!$tabsContainer.length > 0) return

  $tabsContainer.forEach($tabContainer => {
    const $tabs    = $tabContainer.querySelectorAll('tab')
    const $tabBtns = $tabContainer.querySelectorAll('tab-btn a')

    $tabBtns.forEach($tabBtn => {
      $tabBtn.addEventListener('click', e => {
        e.preventDefault()

        ToggleTab($tabContainer, $tabs, $tabBtns, $tabBtn)
      })
    })
  })
}

export default Tabs
